import { transformCdnImageUrl } from "seneca-common/utils/images";

import { ContentSource, ImageAssetParameters } from "../types";

export function getModuleAssets(source: ContentSource): Array<string> {
  return source.values.map((value: any) => value.imgURL);
}

export function transformModuleAssets(
  source: ContentSource,
  assetParams: ImageAssetParameters
): ContentSource {
  return {
    ...source,
    values: source.values.map((value: any) => ({
      ...value,
      imgURL: transformCdnImageUrl(value.imgURL, assetParams.default)
    }))
  };
}
